module.exports = __webpack_public_path__ + "static/media/Filters.a197fbbe.svg";